module.exports = __webpack_public_path__ + "static/media/unionpay.8a10aefc.svg";